<template>

  <HeaderSection />

  <section id="formulario">

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-gray-700 mx-5">

      <div class="container mx-auto max-w-4xl my-7 p-5 lg:p-8 lg:pr-10 bg-white bg-opacity-90 rounded-lg shadow-xl">

        <h1 class="font-bold text-center text-2xl">{{ $t('titulo.credenciales')}} </h1>
        <h1 class="font-bold text-center text-xl mt-2">{{ $t('label.complete.credencial') }}</h1>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2">
            <label class="block mb-1">{{ $t('label.ingrese.documento') }}</label>
            <Field name="documento" v-slot="{ field, errors }" v-model="formData.documento">
              <InputText v-bind="field" type="text" :placeholder="$t('label.documento')"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="documento" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap py-2 mt-3 w-full">
          <button type="submit" class="mt-4 w-full md:w-auto px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded" :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-arrow-circle-down mr-2"></i>{{ $t('boton.descargar.credencial') }}
          </button>
        </div>

      </div>

      <BlockUI :blocked="isSubmitting" fullScreen />

    </Form>

  </section>

</template>

<script lang="ts">
import * as yup from 'yup';

import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import InputText from 'primevue/inputtext';
import BlockUI from 'primevue/blockui';
import HeaderSection from './HeaderSection.vue';

import suiteService, { Acreditado } from 'qreventos-suite/services';
import suiteConfig from '@/services/suite.config';
import { VERIFICADO } from 'qreventos-suite/constantes';

export default defineComponent({
  components: {
    HeaderSection,
    InputText, BlockUI,
    Field, ErrorMessage, Form
  },
  data() {
    return {
      isSubmitting: false,
      formData: {
        documento: '',
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        documento: yup.string().required(this.$t('errors.dni.required')).min(6, this.$t('errors.dni.min')),
      });
    }
  },
  methods: {
    async onSubmit() {
      this.isSubmitting = true;

      try {

        let acreditado:Acreditado = await suiteService.findAcreditadoByFilters(suiteConfig.evento, "dni="+this.formData.documento) as Acreditado;
        if(!acreditado) {
          this.isSubmitting = false;
          Swal.fire({ title: this.$t('global.atencion'),  html: this.$t('mensaje.acreditado.no.existe'), icon: "error" });
          return;
        }

        if(acreditado.estadoAcreditado.id != VERIFICADO) {
          this.isSubmitting = false;
          Swal.fire({ title: this.$t('global.atencion'),  html: this.$t('mensaje.acreditcion.no.verificada'), icon: "error" });
          return;
        }
			
        location.href = "https://apps.qreventos.com/credencial/getCredencial?evento=" + suiteConfig.evento + "&hash=" + acreditado.hash;
      } finally {
        this.isSubmitting = false;
      }
    }
  }
});
</script>
